// extracted by mini-css-extract-plugin
export default {"TextContainer":"TextSection_TextContainer__LkDuO","Title":"TextSection_Title__Sn9kR"};